import { forwardRef, VFC } from "react";
import { EditorCanvas, EditorState, useEditorState } from "src/features/editor";
import { DataGenerator } from "src/features/generator";
import { css } from "src/styles/theme";

export interface PlaygroundProps {
  initialState: () => EditorState;
}

export const Playground: VFC<PlaygroundProps> = forwardRef<
  HTMLDivElement,
  PlaygroundProps
>((props, ref) => {
  const [state, dispatch] = useEditorState(props.initialState);

  return (
    <div className={$playground()} ref={ref}>
      <div className={$canvas()}>
        <EditorCanvas state={state} dispatch={dispatch} />
      </div>
      <div className={$output()}>
        <DataGenerator
          nodes={state.nodes}
          positions={state.positions}
          hideCopyButton
        />
      </div>
    </div>
  );
});

const $playground = css({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  position: "relative",
  overflow: "hidden",

  "@medium": {
    flexDirection: "row",
  },
});

const $canvas = css({
  flexGrow: 1,
  minHeight: "28rem",
  position: "relative",
});

const $output = css({
  width: "100%",
  border: "1px solid $neutralLine",
  borderWidth: "1px 0 0",

  "@medium": {
    width: "30%",
    borderWidth: "0 0 0 1px",
  },
});
